<template>
  <b-button
    :variant="variant"
    :size="size"
    :class="classes"
    @click="() => {
      $emit('update:refresh', true)
      $nextTick(() => {
        // reset refresh
        $emit('update:refresh', false)
      })
    }"
  >
    <feather-icon
      icon="RefreshCcwIcon"
      class="mr-50"
    />
    <span class="align-middle">{{ label }}</span>
  </b-button>
</template>
<script>
import {
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  props: {
    refresh: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: null,
    },
    classes: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
